module.exports = __webpack_public_path__ + "static/media/augendusche_btn_richtig.6b4fb72b.jpg";